// extracted by mini-css-extract-plugin
export default {"container":"Country_container__dyL8O","button":"Country_button__it2J+"};